export const environment = {
  production: false,
  sandbox: false,
  appUrl: "https://performance.portal.deliverysolutions.co/",
  lynkupAppUrl: "https://performance.hub.lynkup.com/",
  serverUrl: "https://performance.api.deliverysolutions.co/",
  streamServiceUrl: "https://performance.streaming.deliverysolutions.co/stream/v2",
  googleMapsAPIKey: "",
  googleTagmanagerID: "GTM-WZPGBW6",
  awsConfig: {
    fileStorage: {
      bucket: "https://qa.files.deliverysolutions.co",
    },
  },
  serviceWorkerEnabled: true,
  checkUpdateInterval: 600000,
  env: "performance",
  googleMapsApiKeyDecryptionPassphrase: "vMrpNRaRAL2RuCF",
  userPilotAuthKey: "",
};
